
    <svg class="svg-icon icon-icon clickable-cursor">
      <use xlink:href="./assets/svg/app-sections.svg#icon-edit"></use>
    </svg>
  